/* ============================================================
   NEYL — cart offers (tilbehør + "Legg til og spar" + bundle-deals) add-to-cart.

   Markup is rendered server-side by snippets/neyl-bundle-offer.liquid. This
   file only handles clicks on [data-neyl-offer-add]:

     data-items        comma-separated variant ids to add (1..3 items)
     data-code         discount code to apply afterwards (ADDON25 / bundle codes)
     data-strip-codes  comma-separated bundle codes to remove first, so an
                       upgrade (2-for -> 3-for) swaps the code instead of
                       stacking. Other codes on the cart (welcome code etc.)
                       are kept.
     data-offer        value written to the hidden line property _neyl_offer

   Flow: POST /cart/add.js { items } -> (optional) GET /cart.js + POST
   /cart/update.js { discount } -> drawer: dispatch 'apps:product-added-to-cart'
   (the theme's quick-cart section listens and re-renders), cart page: reload.

   The drawer re-renders its HTML on every cart change, so everything is
   delegated from document and guarded against double initialisation.
   ============================================================ */

(function () {
  if (window.neylCartOffersInitialized) return;
  window.neylCartOffersInitialized = true;

  var ADD_TIMEOUT = 15000;

  function routeUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root;
    return root ? (root + path).replace(/\/+/g, '/') : '/' + path;
  }

  var JSON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  function splitList(value) {
    var out = [];
    var parts = String(value || '').split(',');
    for (var i = 0; i < parts.length; i++) {
      var v = parts[i].trim();
      if (v) out.push(v);
    }
    return out;
  }

  function errorEl(button) {
    var row = button.closest('[data-neyl-deal], [data-neyl-acc], [data-neyl-addon]');
    return row && row.querySelector('[data-neyl-offer-error]');
  }

  function showError(button, message) {
    var el = errorEl(button);
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(button) {
    var el = errorEl(button);
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  /* Rewrite the cart's discount codes: keep everything that is not a bundle
     code, drop the bundle codes, add the new one. Never rejects: if the code
     cannot be applied, the items are still in the cart at ordinary price. */
  function updateDiscountCodes(stripCodes, addCode) {
    if (!addCode && !stripCodes.length) return Promise.resolve(null);

    var stripUpper = [];
    for (var s = 0; s < stripCodes.length; s++) stripUpper.push(stripCodes[s].toUpperCase());

    return fetch(routeUrl('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = [];
        var existing = (cart && cart.discount_codes) || [];
        for (var i = 0; i < existing.length; i++) {
          var c = existing[i] && existing[i].code;
          if (!c) continue;
          if (stripUpper.indexOf(String(c).toUpperCase()) !== -1) continue;
          if (existing[i].applicable === false) continue;
          codes.push(c);
        }
        if (addCode) {
          var has = false;
          for (var k = 0; k < codes.length; k++) {
            if (String(codes[k]).toUpperCase() === addCode.toUpperCase()) has = true;
          }
          if (!has) codes.push(addCode);
        }

        return fetch(routeUrl('cart/update.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: JSON_HEADERS,
          body: JSON.stringify({ discount: codes.join(',') })
        }).then(function (res) { return res.json(); });
      })
      .catch(function () { return null; });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-neyl-offer-add]');
    if (!button || button.disabled) return;

    e.preventDefault();

    var ids = splitList(button.getAttribute('data-items'));
    if (!ids.length) return;
    if (button.classList.contains('loading')) return;

    var wrap = button.closest('[data-neyl-offers]');
    var source = (wrap && wrap.getAttribute('data-source')) || 'quick-cart';
    var code = (button.getAttribute('data-code') || '').trim();
    var strip = splitList(button.getAttribute('data-strip-codes'));
    var offer = button.getAttribute('data-offer') || 'ja';

    var items = [];
    for (var i = 0; i < ids.length; i++) {
      items.push({ id: ids[i], quantity: 1, properties: { _neyl_offer: offer } });
    }

    clearError(button);
    button.classList.add('loading');

    var failsafe = setTimeout(function () {
      button.classList.remove('loading');
    }, ADD_TIMEOUT);

    fetch(routeUrl('cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: JSON_HEADERS,
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          clearTimeout(failsafe);
          button.classList.remove('loading');
          showError(button, (result.data && result.data.description) || 'Kunne ikke legge i handlekurven.');
          return null;
        }
        return updateDiscountCodes(strip, code).then(function () { return result; });
      })
      .then(function (result) {
        if (!result) return;
        clearTimeout(failsafe);
        button.classList.remove('loading');

        var textEl = button.querySelector('[data-neyl-offer-text]');
        var addedLabel = button.getAttribute('data-label-added');
        if (textEl && addedLabel) textEl.textContent = addedLabel;
        button.disabled = true;

        if (source === 'cart') {
          window.location.reload();
          return;
        }

        document.dispatchEvent(
          new CustomEvent('apps:product-added-to-cart', {
            bubbles: true,
            detail: { item: result.data, source: 'neyl-cart-offers' }
          })
        );
      })
      .catch(function () {
        clearTimeout(failsafe);
        button.classList.remove('loading');
        showError(button, 'Noe gikk galt. Prøv igjen.');
      });
  });
})();
